import { Notification } from "./components";

import "./styles/styles.scss";

const install = (Vue, opts = {}) => {
  Notification.options = opts;
  Vue.prototype.$notify = Notification;
};

const plugin = {
  install
};

export default plugin;
